export default {
  en: {
    title: ""
  },
  pl: {
    projects2024: {
      projectsTitle: "Projekty 2024",
      title:
        "<span style='color: #c4e230'>Czy wiesz jak wiele można zmienić</span> w ciągu jednej doby?</br>My wiemy!",
      summary: "<span>Uczestnicy stworzyli 14 niezwykłych projektów. Trzymamy dalej kciuki za podbijanie świata, bo projekty (i zespoły!) mają potencjał! <br/> Oto najlepsze z nich:</span>",
      winners: 
      {
        image: require("./images/vampireguide.jpg").default,
        name: "Vampire Guide",
        text:
          "<p>Vampire Guide to program dostarczający dane o cieniu budynków w dowolnym miejscu i czasie. Esktraktuje on ich wymiary z map, które w połączeniu z aktualną pozycją słońca określają miejsce padania cienia. Końcowo pokazaliśmy jego zastosowanie w interaktywnej aplikacji Shadow Walk, modyfikując istniejące algorytmy tak, by myślały, że nasłonecznione chodniki są dłuższe. Analizując inne źródła danych, zauważyliśmy możliwości rozwoju biznesu takie jak znajdowanie optymalnych miejsc parkingowych i identyfikowanie ścieżek z sponsorującymi kawiarniami.</p>",
        place: "I MIEJSCE w kategorii projektu stworzonego na hackathonie oraz jako najlepszy projekt wyborem uczestników"
      },
      winners2: 
      {
        image: require("./images/leaflove.jpg").default,
        name: "LeafLoveApp",
        text:
          "LeafLoveApp: Twoje Centrum Specjalistów od Roślin. LeafLoveApp to nowoczesna aplikacja, która wkrótce zrewolucjonizuje sposób, w jaki dbamy o rośliny w domu, biurze i przestrzeniach publicznych. Naszym celem jest połączenie wszystkich zainteresowanych specjalistów od roślin w jednym miejscu, oferując kompleksowe usługi od przygotowania planu opieki, przez aranżację przestrzeni, po jednorazową lub stałą opiekę nad roślinami. Wkrótce dzięki LeafLoveApp, klienci nie będą musieli szukać specjalistów w różnych miejscach. Wszystkie usługi związane z pielęgnacją roślin będą dostępne w jednym miejscu. Niezależnie od tego, czy potrzebujesz porady dotyczącej wyboru roślin, planu opieki, aranżacji wnętrza, czy regularnej pielęgnacji, znajdziesz to w LeafLoveApp. LeafLoveApp to synonim jakości, zaufania i pasji do zieleni.",
        place: "I MIEJSCE w kategorii projektu kontynuowanego",
      },
      projects: [
        {
          image: require("./images/energypark.jpg").default,
          name: "Energy park",
          text:
            "Hardware’owe rozwiązanie, które celem jest wykorzystanie urządzeń na siłowni do generowania prądu.",
          place: "II MIEJSCE",
          posX: "27px",
          posY: "50px"
        },
        {
          name: "Spacerowe bingo",
          image: require("./images/spacerowebingo.jpg").default,
          text:
            "Aplikacja, która zachęca do aktywnego spędzania czasu na świeżym powietrzu. Znajdując kolejne miejsca w rzeczywistej przestrzeni, odkrywamy karty niczym w grze „Kółko i krzyżyk”. Celem jest znalezienie minimum 3 miejsc, które ułożą się w rzędzie, by móc krzyknąć bingo!",
          place: "III MIEJSCE",
          posX: "30px",
          posY: "50px"
        },
        {
          name: "Nucleus",
          image: require("./images/nucleus.jpg").default,
          text:
            "Celem naszego projektu jest zachowanie bioróżnorodności roślin (warzywa, owoce itd.), z nastawieniem na tzw. stare odmiany, które w zastraszającym tempie znikają z naszego krajobrazu bezpowrotnie. Rozwiązanie to platforma edukacyjna - baza wiedzy o starych, zapomnianych odmianach roślin. Dodatkowo w ramach rozwoju platformy użytkownicy będą mogli korzystać z pomocy asystenta ogrodnika w formie czatu oraz prowadzić własny dziennik upraw z możliwością udostępniania, wymiany doświadczeń oraz motywowaniem się wzajemnie z innymi użytkownikami. Poza tym, portal będzie zawierał licznik, który w czasie rzeczywistym pokaże ile nasion starych odmian udało się zachować i zabezpieczyć.",
          place: "WYRÓŻNIENIE",
          posX: "30px",
          posY: "50px"
        },
        {
          name: "Miasto w minutach",
          image: require("./images/miastowminutach.jpg").default,
          text:
            "Sprawdź, czy interesująca Cię lokalizacja spełnia kryteria miasta 15-minutowego. Dokładne kryteria określasz sam. Aplikacja w krótkim czasie zaprezentuje precyzyjne dopasowanie podanego przez Ciebie adresu do Twoich wymagań. Możesz także porównać ze sobą (maksymalnie 3) adresy i łatwo zdecydować, który będzie właściwym wyborem. W niedalekiej przyszłości dodana zostanie heatmapa, która pozwoli wskazać najlepsze adresy według wybranych kategorii. Obecnie aplikacja działa tylko dla Trójmiasta.",
          place: "WYRÓŻNIENIE",
          posX: "30px",
          posY: "50px"
        }
      ]
    },
    data2024: {
      title: "Efekty 2024",
      description: `<p>Hackathon odbył się 2-4 czerwca 2023 roku w formie hybrydowej - w Gdańskim Parku Naukowo - Technologicznym, W Słupskim Inkubatorze Technologicznym oraz online. W wydarzeniu uczestniczyło ok. 150 osób (uczestnicy, mentorzy, eksperci). Wszyscy podjęli się wyzwania, aby w 48 godzin stworzyć projekty wyjątkowe, nowoczesne technologicznie oraz bardzo potrzebne ludziom i naszej planecie.
        </p><br/><p>W ramach wydarzeń wokół  Hack4change, odbył się także  wspólny spływ kajakowy po rzece Reda, wraz ze sprzątaniem terenu wokół spływu. Ponadto w Słupskim Inkubatorze Technologicznym zorganizawliśmy warsztaty z robotyki dla dzieci oraz warsztaty Life Plan Academy dla młodzieży.</p>`,
    },
    partners2024: {
      title: "Partnerzy 2024",
      description: "Chcesz wesprzeć inicjatywę oferując swoją wiedzę i talent lub dostęp do danych? Napisz do nas! Przygotujemy dla Ciebie ofertę współpracy i razem zrobimy coś dobrego. Bądź częścią zmiany!",
      button: "Wypełnij formularz &rarr;",
      boxTitle: "Dołącz do nas",
      partners: {
        title: "Partnerzy 2024",
        logos: [
          {
            title: "Organizatorzy:",
            elements: [
              {
                image:
                  require("./images/PODSTAWOWA codeme_logo_black_red_subtitle_black_rgb.png").default,
                url: "http://codeme.pl/",
              },
              {
                image:  require("./images/LOGO_KA_gold-01.jpg").default,
                url: "https://kaminskiacademy.com/",
              },
              {
                image:  require("./images/urzadpom.png").default,
                url: "https://pomorskie.eu/urzad-marszalkowski-wojewodztwa-pomorskiego/",
              },
              {
                image:  require("./images/Pomorskie_Kompetencje_Jutra_LOGO_1-01.jpg").default,
                url: "https://gospodarka.pomorskie.eu/kategoria/pomorskie-kompetencje-jutra/",
              },
            ],
          },
          {
            title: "Patronat honorowy:",
            elements: [
              {
                image: require("./images/PrezydentMG.jpg").default,
                url: "https://www.gdansk.pl/",
              },
              {
                image: require("./images/pg_poziome_logo_kolor-300x212 alternatywna_2.jpg").default,
                url: "https://pg.edu.pl/",
              },
            ],
          },
          {
            title: "Partnerzy strategiczni:",
            elements: [
              {
                image: require("./images/theprotocol_logo_light (1).png").default,
                url: "https://theprotocol.it/",
              },
            ],
          },
          {
            title: "Partnerzy srebrni:",
            elements: [ 
              {
                image: require("./images/Capgemini_Logo_Color_RGB.png").default,
                url: "https://www.capgemini.com/",
              },
              {
                image: require("./images/speednet.png").default,
                url: "https://speednetsoftware.com/",
              },
            ],
          },
         {
            title: "Partnerzy przestrzeni:",
            elements: [
              {
                image: require("./images/PSI_PSSE.png").default,
                url: "https://www.strefa.gda.pl/",
              },
              {
                image: require("./images/GPNT.png").default,
                url: "https://gpnt.pl/",
              },
            ],
          },
          {
            title: "Partnerzy merytoryczni:",
            elements: [
              {
                image: require("./images/PJATK_shop-1.png").default,
                url: "https://pja.edu.pl/",
              },
              {
                image: require("./images/scalac_logo_2160x1080_(1).png").default,
                url: "https://scalac.io/",
              },
              {
                image: require("./images/wydzia-psychologii-w-sopocie_logo_horizontal_bt.png").default,
                url: "https://swps.pl/struktura/wydzial-psychologii-sopot",
              },   
              {
                image: require("./images/hackerspace.png").default,
                url: "https://hs3.pl/",
              },
              {
                image: require("./images/rsz_interizon.jpg").default,
                url: "https://interizon.pl/",
              },
              {
                image: require("./images/PwC.png").default,
                url: "https://www.pwc.pl/",
              },
              {
                image: require("./images/KAINOS.png").default,
                url: "https://kainos.pl/",
              },
              {
                image: require("./images/pixelmates.png").default,
                url: "",
              },
              {
                image: require("./images/art & science_logo.png").default,
                url: "",
              },
              {
                image: require("./images/DG_logo_mid_res.jpg").default,
                url: "https://www.facebook.com/RyczelDobrzeGada/",
              },
              {
                image: require("./images/jogowaga-logo.jpeg").default,
                url: "https://www.facebook.com/jogowaga",
              },
            ],
          },
          {
            title: "Partnerzy społeczni:",
            elements: [
              {
                image: require("./images/logo RC kwadrat.png").default,
                url: "https://fundacjarc.org.pl/",
              },
            ],
          },
          {
            title: "Partnerzy medialni i społecznościowi:",
            elements: [
              {
                image: require("./images/zielona-gospodarka-logo.png").default,
                url: "https://zielonagospodarka.pl/",
              },
              {
                image: require("./images/Radio_Mors_New_Logo_RGB_Podstawowy_pozytyw.svg").default,
                url: "https://mors.ug.edu.pl/",
              },
              {
                image: require("./images/logo-ngo.png").default,
                url: "https://www.ngo.pl/", 
              },
              {
                image: require("./images/Sektor_logo.jpg").default,
                url: "https://sektor3-0.pl/", 
              },
              {
                image: require("./images/BEST_warsaw-1024x519.png").default,
                url: "https://new.best.warszawa.pl/",
              },
              {
                image: require("./images/pp.jpg").default,
                url: "https://pracodawcypomorza.pl/",
              }, 
              {
                image: require("./images/starter.png").default,
                url: "https://inkubatorstarter.pl/",
              },
              {
                image: require("./images/instytut kultury miejskiej.png").default,
                url: "https://ikm.gda.pl/",
              },
              {
                image: require("./images/kosmonautaLogo.png").default,
                url: " ",
              },
              {
                image: require("./images/logo_sozo-niebieskie_pag.jpg").default,
                url: "https://sozosfera.pl/",
              },
              {
                image: require("./images/logo a11y_.png").default,
                url: "https://www.facebook.com/profile.php?id=61559965273243",
              },
              {
                image: require("./images/hevelianum_logo.png").default,
                url: "https://hevelianum.pl/",
              },
              {
                image: require("./images/Merito.png").default,
                url: "https://www.merito.pl/gdansk/",
              },
            ],
          },
          {
            title: "Partnerzy wspierający:",
            elements: [
              {
                image:  require("./images/kajaki_3.jpg").default,
                url: "https://www.facebook.com/kajaki3miasto/",
              },
              {
                image: require("./images/pzw rumia.png").default,
                url: "https://pzwrumia.pl/",
              },
              {
                image:  require("./images/logo Beka.jpg").default,
                url: "https://npk.org.pl/o-parku-2/formy-ochrony-przyrody-1/rezerwaty-przyrody-3/beka/",
              },
              {
                image:  require("./images/bat.jpg").default,
                url: "https://bat.pl/",
              },
              {
                image:  require("./images/kosakowo_logo_CMYK (1).png").default,
                url: "https://gminakosakowo.pl/",
              },
              {
                image:  require("./images/peko2.jpg").default,
                url: "https://pukpeko.pl/",
              },
              {
                image:  require("./images/logo_WODY-POLSKIE_pl-poziom.jpg").default,
                url: "https://www.wody.gov.pl/",
              },
            ],
          },
        ],
      },
      partners2024Others: {
        logos: [
          {
            title: " ",
            elements: [
              // {
              //   image: require("./images/POMORSKIE-kolor-RGB.png").default,
              //   url: "https://pomorskie.eu/",
              // },
              // {
              //   image: require("./images/ISP_kolor.jpg").default,
              //   url: "https://pomorskie.eu/smart-progress/",
              // }
            ],
          },
        ],
      }
    },
    mentors2024: {
      title: "Mentorzy i eksperci 2024",
      button: "Zobacz więcej &rarr;",
      mentors: [
        {
          id: "marcin",
          image: require("../Mentors/images/marcin_m.jpeg").default,
          name: "Marcin Młyński",
          description:
            "Entuzjasta nowych technologii, koncepcji Internet of Things oraz świata startupów. Koordynator wielu biznesowych wydarzeń dla setek osób oraz organizator kilkudziesięciu hackathonów. Co-founder & CEO CODE:ME, jednej z największych polskich szkół programowania oraz założyciel HACKER:SPACE Trójmiasto, otwartej technologicznej przestrzeni, poświęconej tworzeniu i rozwojowi innowacyjnych projektów. Hackerspace Trójmiasto jest obecnie jedną z największych technologicznych społeczności w północnej Polsce. Uczestnik PFR School of Pioneers, realizowanego we współpracy z University of Cambridge, międzynarodowego programu dedykowanego przedsiębiorcom i wizjonerom w obszarze nowych technologii.",
          title: "CEO, CODE:ME, Founder Hackerspace Trójmiasto",
          linkedin: "https://www.linkedin.com/in/marcin-mlynski/",
        },
        {
          image: require("../Mentors/images/rsz_marek_kaminski.jpg").default,
          name: "Marek Kamiński",
          description:
            "Zdobywca biegunów, założyciel Fundacji i Kaminski Academy. Jako pierwszy na świecie zdobył oba bieguny Ziemi w ciągu jednego roku, bez pomocy z zewnątrz, za co został wpisany do Księgi Rekordów Guinnessa. Inspiruje setki tysięcy ludzi w Polsce i na świecie poprzez książki, filmy, podcasty, webinary i programy trenerskie.\n" +
            "Stworzył Kamiński Academy, której misją jest promowanie wiary w potencjał ludzki i budowanie odporności psychicznej. Daje sprawdzone narzędzia do zmiany i osiągania celów, które od 20 lat zmieniają życie dziesiątek tysięcy ludzi i pomagają w rozwoju osobistym i biznesowym.  \n" +
            "Założyciel Fundacji oraz pomysłodawca międzynarodowego programu transformacyjno-rozwojowego Life Plan Academy dla młodzieży w wieku 14-17 lat, którego celem jest zmiana jakości życia, zapobieganie depresji i budowa własnej wartości, poprzez naukę osiągania indywidualnych celów.\n" +
            "<br/><br/>Aby dowiedzieć się więcej odwiedź: <br/>" +
            "<a href='https://marekkaminskiacademy.com/'>Kaminski Academy</a><br/>" +
            "<a href='https://fundacjamarkakaminskiego.com/'>Fundacja Marka Kaminskiego</a>",
          title:
            "Zdobywca biegunów, Innowator, Twórca Metody Biegun, Kaminski Academy",
          linkedin: "https://pl.linkedin.com/in/kaminskimarek1"
        },
        {
          image: require("../Mentors/images/sergiuszr.png").default,
          name: "Sergiusz Ryczel",
          description:
            "Uczę zachowania przed kamerą, na scenie, w kontakcie z mediami📺 Generalnie pomagam i uczę mówić tak by było ciekawie i by przekazać to co najważniejsze. By nie gubić swoich szans. ",
          title:
            "Trener Medialnych Wystąpień Publicznych🎤Dwujęzyczny Konferansjer🇬🇧 Mówca/Keynote Speaker🎙Konsultant Video Marketingu(EB,EA)🎥Konsultant Marki Osobistej🎩",
          linkedin: "https://www.linkedin.com/in/sergiusz-ryczel/",
        },
        {
          id: "jaroslaw",
          image: require("../Mentors/images/rsz_jaroslaw_p.jpg").default,
          name: "Jarosław Parzuchowski",
          description:
            "Prezes Zarządu Klastra Interizon, największej na Pomorzu instytucji otoczenia biznesu z branży ICT. Pełni także funkcję Przewodniczącego Rady Inteligentnej Specjalizacji Pomorza „Technologie Interaktywne w środowisku nasyconym informatycznie”. Jest członkiem dwóch interdyscyplinarnych zespołów badawczych w ramach Programu Operacyjnego Polska Cyfrowa, realizujących systemy informatyczne dla branży medycznej m.in. narzędzia do tworzenia modeli 3D z danych radiologicznych.",
          title: "CEO, Interizon: Pomorski Klaster ICT",
          linkedin: "https://www.linkedin.com/in/jaroslaw-parzuchowski-3b37b8a1",
        },
        {
          id: "tomaszb",
          image: require("../Mentors/images/tomaszb.jpg").default,
          name: "Tomasz Bogus",
          description:
            "Od ponad 15 lat pomaga budować innowacyjność dzięki technologii i analizie danych. Tworzył i wdrażał jedne z pierwszych rozwiązań IoT (M2M) dla firm takich jak Saur Neptun Gdańsk, Instytutu Energetyki, Zarząd Transportu Miejskiego, Urząd Morski, Grupa Energa, PKP. Ekspert w obszarze sprzedaży i marketingu na rynku USA. Co-founder startupu Effictory (Industry 4.0 - Smart Factory). Absolwent wydziału ETI Politechniki Gdańskiej.",
          title: "Head of Business Development, Scalac",
          linkedin: "https://www.linkedin.com/in/tomaszbogus/",
        },
        {
          id: "jakubw",
          image: require("../Mentors/images/jakubw.png").default,
          name: "mgr inż. Jakub Wilczyński",
          description:
            "Absolwent wydziału Grafiki na Akademii Sztuk Pięknych w Gdańsku, specjalność Grafika Projektowa i Grafiki na PJATK w Gdańsku, gdzie obronił się z wyróżnieniem. Inż. Architektury. W PJATK prowadzi zajęcia z Liternictwa, Fotografii oraz Animacji. Obecnie pracuje jako UX i UI designer i współprowadzi studio projektowe. Z zamiłowania muzyk i akwarysta.",
          title: "Wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk",
          linkedin: " ",
        },
        {
          id: "bartekk",
          image: require("../Mentors/images/bartekk.png").default,
          name: "Bartek Kotowicz",
          description:
            "Pomaga zrozumieć polskie marki. Twórca i wieloletni dyrektor agencji brandingu strategicznego Engram. Ekspert w obszarze marek korporacyjnych i osobistych, strategii marek oraz brandingu. Działa na rzecz polskiego brandingu usprawniając procesy brandingowe i rebrandingowe. Fundator i członek zarządu IBRA Instytutu Brandingowego. Inicjator i współautor Przewodnika Brandingowego. Propagator polskich marek – autor projektu „126 polskich marek”. Członek jury najważniejszych konkursów branżowych (KTR, Rebranding Roku, Projekt Roku STGU). Ułatwia poruszanie się po polskim brandingu za sprawą wystąpień, wykładów, szkoleń, konsultacji i programów mentoringowych.",
          title: "Head of brand, Semcore, członek zarządu, IBRA Instytut Brandingowy",
          linkedin: "https://www.linkedin.com/in/bartekkotowicz/",
        },
        {
          id: "nataliap",
          image: require("../Mentors/images/nataliap.jpg").default,
          name: "Natalia Pawlak",
          description:
            "Od czasów wczesnoszkolnych wiązała swoją przyszłość ze środowiskiem IT. Marzenie to zrealizowała studiując na Politechnice Poznańskiej na kierunku Informatyka. Swoją zawodową wędrówkę rozpoczęła kilka lat temu. Na początku było to testowanie, ale gdzieś zawsze pojawiały się stanowiska związane również z koordynacją pracy oraz zarządzaniem ludźmi. Posiada certyfikacje z zakresu testowania jak i prowadzenia projektów. Stawia na komunikatywność i indywidualne oraz grupowe docenianie współpracowników, ze wskazaniem ich mocnych stron i odpowiednim ukierunkowaniem. W swoim zespole stawia na relacje partnerskie bazujące nie tylko na autorytecie przełożonego, ale również rodzinnej atmosferze. W wolnym czasie czyta książki kryminalne lub ogląda seriale. Ponadto jak tylko pogoda pozwala wyrusza na spacery ze swoimi psiakami.\n" +
            "\nW 2020 roku razem z Karoliną Pawłowską stworzyła markę Fun with bugs. Pod tym szyldem napisały i wydały w modelu self-publishingu książkę „Podróż przez świat testowania”, która w lekki i zabawny sposób uczy testowania. Książka pomogła już setkom osób w przebranżowieniu się i wejściu do IT.",
          title: "Senior Tester at FlexDev - Future-proof Your Business",
          linkedin: "https://www.linkedin.com/in/natalia-pawlak-b9262b57/",
        },
        {
          id: "karolinap",
          image: require("../Mentors/images/karolinap.jpg").default,
          name: "Karolina Pawłowska",
          description:
            "Aktywnie działa w środowisku IT i game dev od paru ładnych lat. Pracowała w różnych firmach i zespołach przy wielkich i małych aplikacjach. Najbardziej lubi dbać o jakość, szczególnie testować eksploracyjnie i dzielić się tą pasją z innymi. Jest fanką gier planszowych i komputerowych, które także testuje wspierając w ten sposób niezależnych twórców gier.\n" +
            "\nW 2020 roku razem z Natalią Pawlak stworzyły markę Fun with bugs. Pod tym szyldem napisały i wydały w modelu self-publishingu książkę „Podróż przez świat testowania”, która w lekki i zabawny sposób uczy testowania. Książka pomogła już setkom osób w przebranżowieniu się i wejściu do IT.",
          title: "Senior QA, trenerka IT i ekspertka ds. jakości oprogramowania",
          linkedin: "https://www.linkedin.com/in/karolina-paw%C5%82owska-70558678/",
        },
        {
          id: "krzysztofk",
          image: require("../Mentors/images/krzysztofk.jpg").default,
          name: "Krzysztof Kanawka",
          description:
            "Dr inż. Krzysztof Kanawka, absolwent AGH, Fachhoschule Muenster i Imperial College London. Obecnie pełni funkcję prezesa zarządu spółki Blue Dot Solutions, która jest MŚP działającą w sektorze kosmicznym w Polsce. Działalność Krzysztofa koncentruje się głównie praktycznym zastosowaniu danych satelitarnych, czyli na aplikacjach telekomunikacyjnych, GNSS, EO oraz analizach technologicznych sektora kosmicznego. Ponadto, od 2016 roku Krzysztof i jego zespół wspierają inne startupy technologiczne w formie akceleratora biznesowego Space3ac. Od tego czasu akcelerator ten wsparł ponad 150 startupów technologicznych z całego świata. Akcelerator zazwyczaj działa w formie „equity-free” i zapewnia kontakty z przemysłem.",
          title: "Dr inż. prezes zarządu Blue Dot Solutions",
          linkedin: "https://www.linkedin.com/in/krzysztofkanawka/",
        },
        {
          id: "patrykj",
          image: require("../Mentors/images/patrykj.jpg").default,
          name: "Patryk Jar",
          description:
            "Od ponad 15 lat działa w branży informatycznej, dostarczając kompleksowe systemy informatyczne.\n" +
            "\n" +
            "Od 2021 roku odpowiedzialny za współpracę z polskimi uczelniami i środowiskiem start-upowym.\n" +
            "\n" +
            "Aktywnie organizował i wspierał wiele inicjatyw edukacyjnych (Code Camp, Code Club, Virtual Work Experience) i innowacyjnych projektów na pograniczu IT i nauki.\n" +
            "\n" +
            "Prócz swoich stricte profesjonalnych zainteresowań, Patryk chętnie posłucha o (mądrych) rozwiązaniach Smart City, Green Software czy szeroko rozumianej pop-kulturze.",
          title: "Lider Techniczny zespołu Innowacji, Kainos",
          linkedin: "https://www.linkedin.com/in/yarpo/",
        },
        {
          id: "kamilt",
          image: require("../Mentors/images/kamilt.jpg").default,
          name: "Kamil Tomaszewski",
          description:
            "Psycholog, doradca zawodowy, psychoterapeuta poznawczo-behawioralny w trakcie certyfikacji. Członek Polskiego Towarzystwa Terapii Poznawczo-Behawioralnej.\n" +
            "W swojej pracy terapeutycznej zajmuje się psychoterapią indywidualną osób dorosłych, zmagających się z różnymi trudnościami natury psychicznej i emocjonalnej. Zainteresowania zawodowe dotyczą: zaburzeń lękowych, afektywnych, osobowości, uzależnień.  Swoją pracę poddaje regularnej superwizji.\n" +
            "Tytuł magistra psychologii uzyskał na Uniwersytecie SWPS w Sopocie, z którym jest zawodowo związany od 2016 roku. Prowadzi zajęcia z zakresu psychologii klinicznej i zdrowia: dynamikę procesów grupowych, wywiad psychologiczny, umiejętności psychologiczne, psychopatologię. Wspiera liczne projekty badawcze, wdrażając rozwiązania przyjazne dla nauki i pracując nad własnym projektem doktoranckim. Ukończył studia z zakresu doradztwa zawodowego i job-coachingu. Prowadzi szkolenia z zakresu umiejętności miękkich. Ukończył szkolenia z zakresu terapii schematów, terapii samouszkodzeń, dialogu motywującego, kurs Terapii Poznawczej Opartej na Uważności (MBCT). Doświadczenie zawodowe zdobywał m.in. w Wojewódzkim Szpitalu Psychiatrycznym im. Prof. Tadeusza Bilikiewicza, Hospicjum im. Ks. E. Dutkiewicza w Gdańsku, Centrum Integracja, Placówka Wsparcia Rodziny i Dziecka – Światłowcy.",
          title: "Wykładowca na Uniwersytecie SWPS w Sopocie, kierownik Pracowni Badań Psychologicznych, psycholog, psychoterapeuta",
          linkedin: " ",
        },
        {
          id: "pamela",
          image: require("../Mentors/images/pamela_k.jpeg").default,
          name: "Pamela Krzypkowska",
          description:
            "Director of Research and Innovation w Ministerstwie Cyfryzacji. AI, Cloud Architect. AI Ethics Board Member w Cogniman. Wykładowczyni na Uniwersytecie Koźmińskiego, a wcześniej także Cloud Solution Architect (Data & AI) w Microsoft.",
          title: "Director of Research and Innovation w Ministerstwie Cyfryzacji",
          linkedin: "https://www.linkedin.com/in/pamela-krzypkowska/",
        },
      {
        id: "mariakt",
        image: require("../Mentors/images/mariakt.jpg").default,
        name: "Maria Koss-Tomaszewska",
        description:
          "Z wykształcenia prawniczką, a z serca kreatywną duszą, w Into the Unknown studio pełnię rolę specjalistki ds. marketingu. Moja zdolność do logicznego myślenia, wspierana przez wykształcenie prawnicze, pozwala mi podejść do strategii marketingowych w sposób pragmatyczny, jednocześnie moja kreatywność inspiruje mnie do poszukiwania innowacyjnych rozwiązań.",
        title: "",
        linkedin: " ",
      },
      {
        id: "sebastianc",
        image: require("../Mentors/images/sebastian cygiert.jpg").default,
        name: "Sebastian Cygiert",
        description:
          "Postdoc w Ideas NCBR i adiunkt na Politechnice Gdańskiej. Poprzednio pracował jako ekespert naukowy w Amazon. Specjalista AI z bogatym doświadczeniem w nauce i przemyśle.",
        title: "Postdoctoral Researcher",
        linkedin: "https://www.linkedin.com/in/sebastiancygert",
      },
      {
        id: "dawidj",
        image: require("../Mentors/images/DawidJozwiak.jpeg").default,
        name: "Dawid Jóźwiak",
        description:
          "Od 2006 roku zajmuję się informatyką i szeroko pojętą technologią. Moje główne obszary specjalizacji to chmura, cyberbezpieczeństwo i rozwiązania infrastrukturalne. Zawodowo jestem SysAdminem typu 'człowiek-orkiestra'. Wielokrotnie pracowałem z zaawansowanymi rozwiązaniami IT dla gigantów technologicznych, takich jak Amazon Web Services i dla dostawców usług zarządzanych będących oficjalnymi partnerami Microsoft. Moje podejście do cyberbezpieczeństwa jest bardzo praktyczne i wierzę, że bezpieczeństwo powinno być czymś powszechnym i przystępnym dla każdej osoby, zwłaszcza w obecnej dobie nadmiernie skomplikowanych słów i definicji.",
        title: "Inżynier Systemów Informatycznych & Specjalista ds. Cyberbezpieczeństwa",
        linkedin: "https://www.linkedin.com/in/dawidjozwiak/",
      },
      {
        id: "kamilh",
        image: require("../Mentors/images/Kamil_Homernik.jpeg").default,
        name: "Kamil Homernik",
        description:
          "Full-stack JavaScript Deweloper i entuzjasta Startupów. Dzielę się swoją wiedzą i doświadczeniem w biznesie, technologii, programowaniu i rolnictwie.",
        title: "Full-stack JavaScript Developer and Startups enthusiast",
        linkedin: "https://www.linkedin.com/in/kamilhomernik/",
      },
      {
        id: "bartoszp",
        image: require("../Mentors/images/b-puszczyk.jpg").default,
        name: "Bartosz Puszczyk",
        description:
          "Projektant UX/UI z ponad dekadą doświadczenia, zdobytego podczas pracy dla firm w Polsce i na świecie. Dąży do wnoszenia wartości poprzez zrozumienie potrzeb użytkowników i przekształcanie ich w funkcjonalne, atrakcyjne produkty. Mówca i trener, pasjonat nowych technologii i street artu. Autor książki 'Rapid design any app from concept to prototype'.<br/><br/> W czym mogę pomóc: <br/><br/>Mogę pomóc zrozumieć perspektywę użytkownika, dopracować wartości w rozwiązaniu problemu i zaproponować metody, które ułatwią obsługę produktu.",
        title: "UX/UI Designer at Scalac",
        linkedin: "https://www.linkedin.com/in/b-puszczyk/",
      },
      {
        id: "ewak",
        image: require("../Mentors/images/Ewa Kryger.jpg").default,
        name: "Ewa Kryger",
        description:
          "Dociekliwa specjalistka Data Science oraz artystka. Z wykształcenia urbanistka i filozofka. Wiele lat pracowała przy projektach planistycznych, partycypacyjnych i edukacyjnych. Skupia się głównie na wizualizacji i analizie procesów zarówno biznesowych, jak i społecznych. Dodatkowo bardzo ważna jest dla niej praca społeczna i wykorzystanie nowych technologii w zakresie AI for Good. Aktywnie działa w obszarze 3 sektora, współzałożycielka WiMLDS (Women in Machine Learning & Data Science) Trójmiasto. Założycielka Fundacji Art Hacks AI, której główną misją będzie tłumaczenie zagadnień związanych z nowymi technologiami, językiem emocji poprzez sztukę. W wolnym czasie, gdy nie czyta, to maluje, zwiedza świat na rowerze oraz tworzy muzykę.",
        title: "Delivery Management in AI | TOP100 Women in Data Science | Project Management | Team-building Facilitation | Art Meditation | AI Ethics | Art Tech",
        linkedin: "https://www.linkedin.com/in/ewakryger/",
      },
      {
        id: "rital",
        image: require("../Mentors/images/Rita Lywczek.png").default,
        name: "Rita Ływczek",
        description:
          "Małgorzata Rita Łyczywek na co dzień pracuje jako Senior Software Engineer w Wizards of the Coast, od lat prowadzi bloga flynerd.pl - pisze o technologiach, uczy programowania i pełni rolę Head of Tech w CODE:ME",
        title: "Head of Technology CODE:ME Foundation | Software Engineer️‍ D&D Beyond | Tech Blogger Mentor | Node.js • TypeScript • AWS • Python",
        linkedin: "https://www.linkedin.com/in/ritalyczywek/",
      },
      {
        id: "karmenr",
        image: require("../Mentors/images/Karmen Radtke.webp").default,
        name: "Karmen Radtke",
        description:
          "Na potrzebę imprez typu hackathon i gamejam opracowałam skuteczny system tworzenia prezentacji, który przyczynił się do niejednokrotnego zajęcia miejsca na podium przez mój zespół. Współpracowałam przy tworzeniu skutecznych prezentacji biznesowych pod pichte do dofinansowań. Na co dzień zajmuję się projektowaniem interfejsów i dbam o przekazywanie maksymalnej ilości informacji w najbardziej przystępny sposób. Chętnie pomogę przy tworzeniu prezentacji, podpowiem sprawdzone rozwiązania i dam feedback.",
        title: "UI & UX Designer I VR I Graphic Art Designer I Gamedev",
        linkedin: "https://www.linkedin.com/in/m-karmen-radtke/",
      },
      {
        id: "joannak",
        image: require("../Mentors/images/Joanna Kotowicz.jpg").default,
        name: "Joanna Kotowicz",
        description:
          "Menedżerka z 15-letnim doświadczeniem w obszarach inwestycji i rozwoju, pracująca w organizacjach na podstawie modelu rozwojowego ESG. Zwolenniczka transformacji energetycznej i zero waste. Współpracowała z sektorem energetycznym i produkcyjnym. Obecnie menedżerka w PKO Bankiem Polskim, gdzie wspiera przedsiębiorstwa w zakresie zrównoważonego rozwoju i finansowania zielonych inwestycji. Absolwentka Collegium Civitas w Warszawie, Politechniki Gdańskiej oraz Akademii Marynarki Wojennej. Ukończyła studia MBA Zarządzanie Polityką Energetyczną i Klimatyczną.",
        title: "MBA in energy and climate I Future Oriented Person | Zero-emission Oriented Manager | Sustainability Expert",
        linkedin: "https://www.linkedin.com/in/joannakotowicz/",
      },
      {
        id: "basiaj",
        image: require("../Mentors/images/basia_jagoda.jpg").default,
        name: "Basia Jagoda",
        description:
          "Basia jest managerka projektów PR dla branży technologicznej i interaktywnej. Zawodowo związana z branżą IT od 2013 – pracowała z łódzkimi software house’ami, obecnie w zespole agencji Linkleaders współtworzy projekty PR m. in. dla theprotocol.it. Z pochodzenia pomorzanka, z wyboru łodzianka. Reprezentuje the:protocol jako ambasadorka raportu „Polacy na cyfrowej równoważni. Cyfrowy ślad technologii 2024”",
        title: "PR dla branży IT",
        linkedin: "https://www.linkedin.com/in/basiajagoda/",
      },
      {
        id: "stanislaws",
        image: require("../Mentors/images/Stanislaw_Szultka.jpg").default,
        name: "Stanislaw Szultka",
        description:
          "Doświadczony menedżer z udokumentowaną historią pracy w branży think tanków. Profesjonalista w zarządzaniu produktem, posiadający umiejętności w zakresie negocjacji, planowania biznesowego, analizy, innowacji i przedsiębiorczości.",
        title: "Dyrektor Departamentu Rozwoju Gospodarczego w Urząd Marszałkowski Województwa Pomorskiego",
        linkedin: "https://www.linkedin.com/in/stanislawszultka/",
      },
      {
        id: "alicjagk",
        image: require("../Mentors/images/alicjagk.jpg").default,
        name: "Alicja Gaładyk-Korytko",
        description:
          `Na co dzień stara się łączyć kreatywność z analitycznym spojrzeniem. Obecnie zajmuje się szeroko rozumianym marketingiem marki the:protocol. Koordynuje obecność marki na eventach, jest zaangażowana w tworzenie komunikacji i  szeroko zasięgowych kampanii do użytkowników. Posiada doświadczenie w zarządzaniu projektami z pogranicza marketingu i IT. Ma za sobą wieloletnie doświadczenie w sektorze obsługi klienta, dzięki czemu patrzy na projekty z dużo szerszej perspektywy.
  Edukację wyższą rozpoczęła od obronienia tytułu inżyniera biotechnologii ze specjalizacją roślinną, następnie zmieniła obszar i zrobiła studia magisterskie w Szkole Głównej Handlowej w Warszawie z zakresu e-biznesu i marketingu internetowego.
  Prywatnie angażuje się w dodatkowe projekty IT, wychodząc z założenia, że jeśli czegoś nie umie, a jest jej potrzebne, to najwyższy czas spróbować się tego nauczyć.`,
        title: "Specjalistka ds. Marketingu w the:protocol",
        linkedin: "https://www.linkedin.com/in/alicjaga%C5%82adykkorytko/",
      },
      {
        id: "mateuszb",
        image: require("../Mentors/images/mateuszb.jpg").default,
        name: "Mateusz Bartoszewski",
        description: `Mateusz Bartoszewski, absolwent Wydziału Biologii UG.
  Z wykształcenia biolog-parazytolog, który zgłębiał tajniki życia kleszczy. Obecnie zawodowo związany z Hevelianum, gdzie zajmuje się popularyzacją nauki i edukacją ekologiczną. W swojej pracy szczególnie mocno przygląda się przyrodzie Góry Gradowej i gdańskiego Brzeźna, a w kręgu jego największych zainteresowań znajdują się owady, rosnące tam „chwasty” i wodne stworzenia, które można spotkać w akwariach Hevelianum. W wolnych chwilach zwiedza inne światy podczas sesji RPG, wytęża mózg podczas grania w planszówki lub relaksuje się malując figurki do wyżej wymienionych.`,
        title: "Specjalista ds. Edukacji Ekologicznej w Hevelianum",
        linkedin: "https://www.linkedin.com/in/mateusz-bartoszewski-296b81197/",
      },
      {
        id: "monikan",
        image: require("../Mentors/images/monikan.jpg").default,
        name: "Monika Niegrzybowska",
        description: `Senior Frontend Developer w Sigma IT Poland, z ponad 6-letnim doświadczeniem w branży IT, gdzie skupia się na tworzeniu intuicyjnych, dużych w skali aplikacji webowych z mikrofrontendami na czele. Na co dzień pracuje z React.js, TypeScript, Jest. Po godzinach wspiera kobiety w środowiskach IT dzieląc się wiedzą programistyczną oraz jest jedną z programistek w projekcie Żeton w Hackerspace. Siły regeneruje grając w planszówki i praktykując jogę.`,
        title: "Senior Frontend Developer | React | JavaScript",
        linkedin: "https://www.linkedin.com/in/monikaniegrzybowska",
      },
      {
        id: "magdalenaj",
        image: require("../Mentors/images/magdalanaj.jpg").default,
        name: "Magdalena Jabłońska",
        description: `Ponad 25 lat temu zaczynała w dyplomacji, potem w branży eventowej i działach marketingu aż po sektor pozarządowy. W każdym z tych obszarów zajmowała się głównie budową wizerunku i tworzeniem treści. Jest całkiem niezłym copywriterem, kocha słowa, żonglowanie nimi oraz komunikowanie za ich pomocą wartościowych znaczeń. Urodzona networkerka – posiada moc łączenia ludzi wokół małych i dużych spraw, szczególnie spod znaku CSR-u.<br/><br/>
        W 2016 roku wróciła z Warszawy do rodzinnego Gdańska i całkowicie przeniosła swoje moce przerobowe do sektora trójmiejskich organizacji pozarządowych, zaczynając od koordynacji Gdańsk Business Run. Od 2018 roku współpracowała ze Stowarzyszeniem Morena jako trenerka w tematyce promowania młodzieżowych projektów społecznych oraz działalności spółdzielni uczniowskich. W styczniu 2021 dołączyła do Fundacji RC, gdzie współtworzy Kreatywny Dział PR jako specjalistka ds. komunikacji i budowania partnerstw oraz jako doradczyni w Gdańskim Centrum Organizacji Pozarządowych w zakresie tych dwóch zagadnień. 
  Jest pomysłodawczynią Spółdzielni Socjalnej Zeroban, która przerabia
   niepotrzebne materiały reklamowe na torby i różne akcesoria. Najtrafniej pasuje do niej określenie „innowatorka zmian społecznych, która wymyśla, szkoli, doradza i sieciuje.” Jej aktualna zajawka to społeczna odpowiedzialność NGO, ISO 26000 oraz ESG.`,
        title: " ",
        linkedin: "https://www.linkedin.com/in/magdalena-jablonska/",
      },
      {
        id: "wojciechl",
        image: require("../Mentors/images/wojciechl.jpg").default,
        name: "Wojciech Leonowicz",
        description: `Aktywnie wspiera startupy na wczesnym etapie rozwoju uczestnicząc w lokalnych, krajowych i międzynarodowych mechanizmach wsparcia. Brał udział w akceleracji 200+ zespołów, które pracowały z ponad 20 dużymi przedsiębiorstwami i korporacjami.`,
        title: "Bridging startup tech supply with business demands",
        linkedin: "https://www.linkedin.com/in/wojciech-leonowicz/",
      },
      {
        id: "piotrc",
        image: require("../Mentors/images/piotrc.jpg").default,
        name: "Piotr Cichocki",
        description: `Programista .net z blisko dekadą doświadczenia w tworzeniu aplikacji webowych w środowiskach chmurowych.
  W swojej pracy mocno stawia na perspektywę klienta i jego potrzeby. Tworzył rozwiązania dla branży turystycznej, inwestycyjnej, logistycznej, komorniczej oraz sądów.
  W ostatnich latach współtworzy portal the:protocol od strony backendowej.`,
        title: "Senior Backend Developer the:protocol w Grupie Pracuj",
        linkedin: "https://www.linkedin.com/in/piotr-cichocki-b92b3791/",
      },
      {
        id: "maciejb",
        image: require("../Mentors/images/maciejb.jpg").default,
        name: "Maciej Budzisz",
        description: `Specjalista w zakresie cyfrowej dostępności z pięcioletnim stażem, który przeprowadził ponad 500 przeglądów witryn internetowych i aplikacji na urządzenia mobilne.
  <br/>
  Absolwent wydziału Zarządzania na Akademii Morskiej w Gdyni. Poza zawodowymi obowiązkami, żywi zamiłowanie do aktywności fizycznej i nauk o zachowaniu, co odzwierciedla się w jego roli przewodniczącego w Organizacji Aktywne Kosakowo.
  <br/>
  Jego percepcja aspektów technicznych oraz humanistycznych w dziedzinie dostępności wynika z synergii profesjonalnych kompetencji i prywatnych zainteresowań.`,
        title: "Ekspert ds. dostępności WCAG",
        linkedin: "https://www.linkedin.com/in/budziszmaciej/",
      },
      {
        id: "wojtekw",
        image: require("../Mentors/images/wojtek-wozniak.jpg").default,
        name: "Wojtek Woźniak",
        description: `No-Code Developer w <a href="https://www.tonik.com" target="_blank">https://www.tonik.com</a>, który magicznie zamienia pomysły w rzeczywistość bez pisania linijki kodu. Wojtek na codzień działa z narzędziami jak Webflow, Bubble.io, Make.com, Zapier i wszystkim, co nosi w sobie ducha "no-code". Jego projekty obejmują komercyjne produkty i strony internetowe dla firm o różnej skali działania, z szczególnym uwzględnieniem współpracy ze start-upami. Jego bazą jest przecudowna Gdynia, gdzie regeneruje siły biegając po lesie i plaży z jego psem, Plamą. Jego kulinarne guilty pleasures to pizza i donuty, które chętnie konsumuje, najlepiej na przemian.`,
        title: "Founder: gfluo.com / Webflow expert",
        linkedin: "https://www.linkedin.com/in/woz/",
      },
      ]
    },
    workshops2024: {
      title: "Warsztaty 2024",
      description: "Przed hackathonem Hack4Change odbyła się seria warsztatów, które pomogły uczestnikom przygotowac się do udziału w wydarzeniu. Zobacz co udało nam się zorganizować!",
      button: "Dowiedz się więcej &rarr;",
      workshops: [
        {
          id: "1",
          mentorId: "pk",
          image: require("../Mentors/images/pamela_k.jpeg").default,
          name: " Pamela Krzypkowska",
          title: "Director of Research and Innovation w Ministerstwie Cyfryzacji",
          description: `W dobie dynamicznych zmian technologicznych, omówimy kluczowe wyzwania i trendy w zakresie ekologii, sztucznej inteligencji, edukacji i idei life long learning. Skupimy się na roli innowacji w rozwiązywaniu problemów globalnych i lokalnych, a także na tym, jak nowe technologie mogą wspierać zrównoważony rozwój oraz poprawę jakości życia. Poznamy inspirujące przykłady i podyskutujemy o przyszłości z ekspertami.
  <br/><br/>
  Spotkanie rozpocznie <strong>Pamela Krzypkowska</strong> - niezwykła osobistość, której samo bio mogłoby być dobrą książką 😉 Director of Research and Innovation w Ministerstwie Cyfryzacji. AI, Cloud Architect. AI Ethics Board Member w Cogniman. Wykładowczyni na Uniwersytecie Koźmińskiego, a wcześniej także Cloud Solution Architect (Data & AI) w Microsoft.
  <br/><br/>
  W drugiej części spotkania pojawi się  <strong>Basia Jagoda</strong> reprezentująca firmę the:protocol z tematem <strong>“Wyolbrzymiana, pomniejszana czy przerzucana jak gorący kartofel? Kto jest odpowiedzialny za ekologię cyfrową według specjalistek i specjalistów IT”</strong>
  Basia jest managerka projektów PR dla branży technologicznej i interaktywnej. Zawodowo związana z branżą IT od 2013 – pracowała z łódzkimi software house’ami, obecnie w zespole agencji Linkleaders współtworzy projekty PR m. in. dla theprotocol.it. Z pochodzenia pomorzanka, z wyboru łodzianka. Reprezentuje the:protocol jako ambasadorka raportu „Polacy na cyfrowej równoważni. Cyfrowy ślad technologii 2024”.</strong> 
  <br/><br/>
  Na koniec spotkania poprowadzimy krótką dyskusję na temat nowych technologii, sztucznej inteligencji, rynku pracy i tego jaki wpływ ma na nie ekologia. Spotkanie poprowadzi <strong>Marcin Młyński</strong>, CEO w Fundacji CODE:ME i Hackerspace Trójmiasto; absolwent PFR School of Pioneers, realizowanego we współpracy z University of Cambridge, międzynarodowego programu dedykowanego przedsiębiorcom i wizjonerom w obszarze 
  nowych technologii.
  `,
          fullDescription: `W dobie dynamicznych zmian technologicznych, omówimy kluczowe wyzwania i trendy w zakresie ekologii, sztucznej inteligencji, edukacji i idei life long learning. Skupimy się na roli innowacji w rozwiązywaniu problemów globalnych i lokalnych, a także na tym, jak nowe technologie mogą wspierać zrównoważony rozwój oraz poprawę jakości życia. Poznamy inspirujące przykłady i podyskutujemy o przyszłości z ekspertami.
  <br/><br/>
  Spotkanie rozpocznie <strong>Pamela Krzypkowska</strong> - niezwykła osobistość, której samo bio mogłoby być dobrą książką 😉 Director of Research and Innovation w Ministerstwie Cyfryzacji. AI, Cloud Architect. AI Ethics Board Member w Cogniman. Wykładowczyni na Uniwersytecie Koźmińskiego, a wcześniej także Cloud Solution Architect (Data & AI) w Microsoft.
  <br/><br/>
  W drugiej części spotkania pojawi się  <strong>Basia Jagoda</strong> reprezentująca firmę the:protocol z tematem <strong>“Wyolbrzymiana, pomniejszana czy przerzucana jak gorący kartofel? Kto jest odpowiedzialny za ekologię cyfrową według specjalistek i specjalistów IT”</strong>
  Basia jest managerka projektów PR dla branży technologicznej i interaktywnej. Zawodowo związana z branżą IT od 2013 – pracowała z łódzkimi software house’ami, obecnie w zespole agencji Linkleaders współtworzy projekty PR m. in. dla theprotocol.it. Z pochodzenia pomorzanka, z wyboru łodzianka. Reprezentuje the:protocol jako ambasadorka raportu „Polacy na cyfrowej równoważni. Cyfrowy ślad technologii 2024”</strong> 
  <br/><br/>
  Na koniec spotkania poprowadzimy krótką dyskusję na temat nowych technologii, sztucznej inteligencji, rynku pracy i tego jaki wpływ ma na nie ekologia. Spotkanie poprowadzi <strong>Marcin Młyński</strong>, CEO w Fundacji CODE:ME i Hackerspace Trójmiasto; absolwent PFR School of Pioneers, realizowanego we współpracy z University of Cambridge, międzynarodowego programu dedykowanego przedsiębiorcom i wizjonerom w obszarze 
  nowych technologii.
  `,
          workshop: "Globalne (i lokalne) wyzwania w świecie innowacji",
          date: "18.06.2024, 18:00 – 20:00 <br/> Online",
          tutorDesc: "Director of Research and Innovation w Ministerstwie Cyfryzacji. AI, Cloud Architect. AI Ethics Board Member w Cogniman. Wykładowczyni na Uniwersytecie Koźmińskiego, a wcześniej także Cloud Solution Architect (Data & AI) w Microsoft.",
          linkedin: "https://www.linkedin.com/in/pamela-krzypkowska/",
          secondTutor: {
            image: require("../Mentors/images/basia_jagoda.jpg").default,
            name: "Basia Jagoda",
            title: "PR dla branży IT",
            tutorDesc: "Basia jest managerka projektów PR dla branży technologicznej i interaktywnej. Zawodowo związana z branżą IT od 2013 – pracowała z łódzkimi software house’ami, obecnie w zespole agencji Linkleaders współtworzy projekty PR m. in. dla theprotocol.it. Z pochodzenia pomorzanka, z wyboru łodzianka. Reprezentuje the:protocol jako ambasadorka raportu „Polacy na cyfrowej równoważni. Cyfrowy ślad technologii 2024”",
            linkedin: "https://www.linkedin.com/in/basiajagoda/"
          },
          thirdTutor: {
            image: require("../Mentors/images/marcin_m.jpeg").default,
            name: "Marcin Młyński",
            title: "CEO, CODE:ME, Founder Hackerspace Trójmiasto",
            tutorDesc: "Entuzjasta nowych technologii, koncepcji Internet of Things oraz świata startupów. Koordynator wielu biznesowych wydarzeń dla setek osób oraz organizator kilkudziesięciu hackathonów. Co-founder & CEO CODE:ME, jednej z największych polskich szkół programowania oraz założyciel HACKER:SPACE Trójmiasto, otwartej technologicznej przestrzeni, poświęconej tworzeniu i rozwojowi innowacyjnych projektów. Hackerspace Trójmiasto jest obecnie jedną z największych technologicznych społeczności w północnej Polsce. Uczestnik PFR School of Pioneers, realizowanego we współpracy z University of Cambridge, międzynarodowego programu dedykowanego przedsiębiorcom i wizjonerom w obszarze nowych technologii.",
            linkedin: "https://www.linkedin.com/in/marcin-mlynski/",
          }
        },
        {
          id: "2",
          mentorId: "jw",
          image: require("../Mentors/images/jakubw.png").default,
          name: "mgr inż. Jakub Wilczyński",
          title: "Wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk",
          description: "Figma to potężne narzędzie, które możne ułatwić tworzenie aplikacji i szybkich prototypów. To szczególnie cenna umiejętność na hackathonie. Warsztaty poprowadzi Jakub Wilczyński - wykładowca na Wydziale Sztuki Nowych Mediów, PJATK Gdańsk. Jakub Będzie także mentorem podczas hackathonu.",
          fullDescription: `"Warsztaty projektowania aplikacji w Figmie" rozpoczną się od wprowadzenia do interfejsu i podstawowych funkcji tego narzędzia do projektowania. Uczestnicy dowiedzą się, jak współpracować w czasie rzeczywistym na jednym projekcie, co umożliwia łatwą komunikację i synchronizację zespołu projektowego. Warsztaty obejmą następujące zagadnienia:
  <br/><br/>
  "Frame" jako podstawowa jednostka konstrukcyjna, pozwalająca na tworzenie responsywnych i zorganizowanych układów.
  <br/><br/>
  Wykorzystanie siatek, wierszy i kolumn do precyzyjnego rozmieszczania elementów zapewnia spójność i estetykę projektu. Uczestnicy nauczą się, jak konfigurować i dostosowywać te siatki, aby odpowiadały ich potrzebom projektowym.
  <br/><br/>
  "Smart Animate", która umożliwia tworzenie płynnych przejść między ekranami i elementami interfejsu.
  <br/><br/>
  "Auto Layout" pozwala na automatyczne dostosowywanie rozmiaru i położenia elementów, co jest szczególnie przydatne przy projektowaniu responsywnych interfejsów.`,
          workshop: "Warsztaty projektowania aplikacji w Figmie",
          date: "19.06.2024, 18:00 – 19:00 <br/> Online",
          tutorDesc: "Absolwent wydziału Grafiki na Akademii Sztuk Pięknych w Gdańsku, specjalność Grafika Projektowa i Grafiki na PJATK w Gdańsku, gdzie obronił się z wyróżnieniem. Inż. Architektury. W PJATK prowadzi zajęcia z Liternictwa, Fotografii oraz Animacji. Obecnie pracuje jako UX i UI designer i współprowadzi studio projektowe. Z zamiłowania muzyk i akwarysta.",
          linkedin: " "
        },
        {
          id: "3",
          mentorId: "pj",
          image: require("../Mentors/images/patrykj.jpg").default,
          name: "Patryk Jar",
          title: "Lider Techniczny zespołu Innowacji, Kainos",
          description: "Jak sprawdzić, aby wytwarzane przez nas rozwiązania cyfrowe miały mniejszy negatywny wpływ na środowisko? Czy to ma sens? Jak to zrobić i czy przypadkiem nie da się na tym sporo zaoszczędzić/zarobić? Jeśli którekolwiek z tych pytań Cię zainteresowało to te warsztaty są dla Ciebie",
          fullDescription: `Jak sprawdzić, aby wytwarzane przez nas rozwiązania cyfrowe miały mniejszy negatywny wpływ na środowisko? Czy to ma sens? Jak to zrobić i czy przypadkiem nie da się na tym sporo zaoszczędzić/zarobić? Jeśli którekolwiek z tych pytań Cię zainteresowało to te warsztaty są dla Ciebie :)`,
          workshop: "Green Software",
          date: "22.06.2024, 21:00",
          tutorDesc:
            "Od ponad 15 lat działa w branży informatycznej, dostarczając kompleksowe systemy informatyczne.\n" +
            "\n" +
            "Od 2021 roku odpowiedzialny za współpracę z polskimi uczelniami i środowiskiem start-upowym.\n" +
            "\n" +
            "Aktywnie organizował i wspierał wiele inicjatyw edukacyjnych (Code Camp, Code Club, Virtual Work Experience) i innowacyjnych projektów na pograniczu IT i nauki.\n" +
            "\n" +
            "Prócz swoich stricte profesjonalnych zainteresowań, Patryk chętnie posłucha o (mądrych) rozwiązaniach Smart City, Green Software czy szeroko rozumianej pop-kulturze.",
          linkedin: "https://www.linkedin.com/in/yarpo/"
        },
        {
          id: "joga",
          mentorId: "yoga",
          image: require("../Mentors/images/yoga.png").default,
          name: "Gosia Olewniak",
          title: "Nauczycielka jogi, matka, odkrywca, poszukiwaczka",
          description: "Zajęcia jogi, relaksu i oddychania poprowadzi Gosia Olewniak - nauczycielka jogi, matka, odkrywca, poszukiwaczka :)",
          fullDescription: "Zajęcia jogi, relaksu i oddychania poprowadzi Gosia Olewniak - nauczycielka jogi, matka, odkrywca, poszukiwaczka :)",
          workshop: "Joga",
          date: "22.06.2024 9:00 - 10:15 <br/>Stacjonarnie Gdański Park Naukowo - Technologiczny",
          tutorDesc: "Moja baza to joga metodą Iyengara, na to nakładam pracę z powięzią i taśmami anatomicznymi. Kładę duży nacisk na uważność i budowanie świadomości ciała i kontaktu z nim.\n" +
            "Uwielbiam praktykować w naturze. Jest wtedy przestrzeń, kolor, powiew wiatru, szum drzew, śpiew ptaków, dotyk trawy, drzewa. Energia przepływa harmonizując i dostrajając się do natury.\n" +
            "Co daje joga sama w sobie - na poziomie fizycznym większe poczucie ciała i jego kontroli, zwiększenie zakresów ruchu, utrzymanie ruchomości stawów, nasmarowanie, a przez to odczucie lekkości w ciele.\n" +
            "A na poziomie duchowym - wyciszenie, uważność na siebie i swoje potrzeby, świadomość ciała i otoczenia.\n" +
            "Można mnie znaleźć w Gdańsku na Chełmie i Oruni\n",
          linkedin: "https://www.facebook.com/jogowaga"
        },
        {
          id: "4",
          mentorId: "ek",
          image: require("../Mentors/images/Ewa Kryger.jpg").default,
          name: "Ewa Kryger",
          title: "Delivery Management in AI | TOP100 Women in Data Science | Project Management | Team-building Facilitation | Art Meditation | AI Ethics | Art Tech",
          description: `Wdech i wydech! Oddech! Oddychaj! Oddech napędza i odżywia cały organizm! Podczas warsztatów będzie można nasycić się energią własnego oddechu. Jest to doskonały wstęp by praktykować medytację.
  Gdy już dotlenimy organizmy, rozpoczniemy twórczą kreację! By rozruszać nasze ciała i tkwiące w nich emocje. Rozbudzimy w sobie kreację, powstanie wspólny obraz naszej kreatywności, którego punktem wyjściowym będzie mandala.`,
          fullDescription: `Wdech i wydech! Oddech! Oddychaj! Oddech napędza i odżywia cały organizm! Podczas warsztatów będzie można nasycić się energią własnego oddechu. Jest to doskonały wstęp by praktykować medytację.
  Gdy już dotlenimy organizmy, rozpoczniemy twórczą kreację! By rozruszać nasze ciała i tkwiące w nich emocje. Rozbudzimy w sobie kreację, powstanie wspólny obraz naszej kreatywności, którego punktem wyjściowym będzie mandala.`,
          workshop: "Art medytacje",
          date: "22.06.2024, 9:00 - 10:00 <br/> Stacjonarnie Gdański Park Naukowo - Technologiczny",
          tutorDesc: `Dociekliwa specjalistka Data Science oraz artystka. Z wykształcenia urbanistka i filozofka. Wiele lat pracowała przy projektach planistycznych, partycypacyjnych i edukacyjnych. Skupia się głównie na wizualizacji i analizie procesów zarówno biznesowych, jak i społecznych. Dodatkowo bardzo ważna jest dla niej praca społeczna i wykorzystanie nowych technologii w zakresie AI for Good. Aktywnie działa w obszarze 3 sektora, współzałożycielka WiMLDS (Women in Machine Learning & Data Science) Trójmiasto. Założycielka Fundacji Art Hacks AI, której główną misją będzie tłumaczenie zagadnień związanych z nowymi technologiami, językiem emocji poprzez sztukę. W wolnym czasie, gdy nie czyta, to maluje, zwiedza świat na rowerze oraz tworzy muzykę.`,
          linkedin: "https://www.linkedin.com/in/ewakryger/"
        },
      ]
    }
  }
}
